// Helpers de exportación para módulos ESG (CSV + PDF print)
// Cada indicador lleva framework + código (GRI, GRESB, ESRS, EU Taxonomy)

export function downloadCSV(rows, filename) {
  if (!rows || rows.length === 0) return
  const cols = Object.keys(rows[0])
  const esc = v => {
    if (v == null) return ''
    const s = String(v).replace(/"/g, '""')
    return /[",\n;]/.test(s) ? `"${s}"` : s
  }
  const csv = [cols.join(';'), ...rows.map(r => cols.map(c => esc(r[c])).join(';'))].join('\n')
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

export function openPrintWindow({ title, projectName, sections }) {
  const w = window.open('', '_blank', 'width=1024,height=768')
  if (!w) { alert('Bloqueado: permite popups para descargar el PDF'); return }
  const today = new Date().toISOString().slice(0, 10)
  const sectionsHtml = sections.map(s => `
    <h2>${s.title}</h2>
    ${s.subtitle ? `<p class="sub">${s.subtitle}</p>` : ''}
    <table>
      <thead><tr>${s.cols.map(c => `<th>${c}</th>`).join('')}</tr></thead>
      <tbody>${s.rows.map(r => `<tr>${r.map(c => `<td>${c == null ? '—' : c}</td>`).join('')}</tr>`).join('')}</tbody>
    </table>
  `).join('')
  w.document.write(`<!DOCTYPE html>
<html lang="es"><head><meta charset="utf-8"><title>${title}</title>
<style>
  @page { size: A4; margin: 18mm 14mm; }
  body { font-family: -apple-system, BlinkMacSystemFont, sans-serif; color: #2C2017; padding: 0; margin: 0; }
  h1 { font-size: 18px; color: #3B2F2F; border-bottom: 2px solid #8D9A2E; padding-bottom: 6px; margin-bottom: 4px; }
  h2 { font-size: 13px; color: #5C4A3A; margin: 20px 0 6px; border-left: 3px solid #8D9A2E; padding-left: 8px; }
  .meta { font-size: 10px; color: #7A6A5A; margin-bottom: 18px; }
  .sub { font-size: 10px; color: #7A6A5A; margin: 0 0 8px; }
  table { width: 100%; border-collapse: collapse; font-size: 10px; margin-bottom: 6px; }
  th { background: #EDE7DE; color: #5C4A3A; text-align: left; padding: 5px 8px; border-bottom: 1px solid #DDD5C8; font-weight: 600; }
  td { padding: 4px 8px; border-bottom: 1px solid #F0EBE2; }
  tbody tr:nth-child(even) { background: #FAF7F3; }
  .footer { font-size: 9px; color: #B0A89E; margin-top: 24px; border-top: 1px solid #DDD5C8; padding-top: 8px; }
  @media print { .no-print { display: none; } }
  .no-print { position: fixed; top: 12px; right: 12px; }
  .no-print button { background: #3B2F2F; color: white; border: 0; padding: 8px 14px; border-radius: 6px; cursor: pointer; font-size: 12px; }
</style></head><body>
<div class="no-print"><button onclick="window.print()">Imprimir / Guardar PDF</button></div>
<h1>${title}</h1>
<div class="meta">Proyecto: <strong>${projectName}</strong> · Fecha: ${today}</div>
${sectionsHtml}
<div class="footer">Generado por la app BREEAM ES · HAUS · Datos derivados de evaluaciones BREEAM y/o lecturas de sensores building_sensors.</div>
<script>setTimeout(() => window.print(), 400)</script>
</body></html>`)
  w.document.close()
}
